// Données mock FR - Solid Consulting

export const companyInfo = {
  name: "Solid Consulting",
  tagline: "Ingénierie solide. Impact réel.",
  description:
    "Partenaire conseil IT senior livrant des solutions technologiques fiables et orientées résultats.",
  email: "contact@solidconsulting.fr",
  phone: "+33 6 35 63 97 43",
  address: "44 av de lattre de tassigny, Marcq-en-Barœul 59700, France",
};

export const navigation = [
  { name: "Services", href: "/services" },
  { name: "Études de cas", href: "/case-studies" },
  { name: "À propos", href: "/about" },
  { name: "Blog", href: "/blog" },
  { name: "Contact", href: "/contact" },
];

export const services = [
  {
    id: "web-development",
    title: "Développement Web",
    shortDescription:
      "Applications SPA modernes, portails, tableaux de bord et applications B2B/B2C avec les frameworks les plus récents.",
    description:
      "Nous développons des applications web performantes et évolutives qui génèrent des résultats business. Des tableaux de bord complexes aux plateformes orientées client, notre équipe livre des implémentations pixel-perfect avec une architecture robuste.",
    technologies: ["React", "Angular", "Vue.js", "Next.js", "TypeScript"],
    missions: [
      "Développement d'applications monopage (SPA)",
      "Création de portails d'entreprise",
      "Implémentation de tableaux de bord temps réel",
      "Plateformes e-commerce B2B/B2C",
      "Progressive Web Apps (PWA)",
    ],
    outcomes: [
      "Temps de chargement 50% plus rapide",
      "Engagement utilisateur amélioré",
      "Taux de rebond réduit",
      "Expérience multi-appareils fluide",
    ],
  },
  {
    id: "mobile-development",
    title: "Développement Mobile",
    shortDescription:
      "Applications mobiles natives et cross-platform pour iOS et Android avec une expérience utilisateur exceptionnelle.",
    description:
      "Nous créons des applications mobiles que les utilisateurs adorent. Qu'elles soient natives ou cross-platform, nos apps sont conçues avec la performance, la sécurité et l'évolutivité en tête.",
    technologies: [
      "React Native",
      "Flutter",
      "Swift",
      "Kotlin",
      "iOS",
      "Android",
    ],
    missions: [
      "Développement natif iOS et Android",
      "Développement d'apps cross-platform",
      "Modernisation d'applications mobiles",
      "Optimisation App Store",
      "Intégration backend mobile",
    ],
    outcomes: [
      "Notes App Store 4.5+",
      "Coûts de développement réduits",
      "Time-to-market accéléré",
      "UX cross-platform cohérente",
    ],
  },
  {
    id: "backend-apis",
    title: "Backend & APIs",
    shortDescription:
      "Architecture microservices robuste et développement API-first avec Java, Spring Boot, Node.js.",
    description:
      "Nous concevons et implémentons des systèmes backend évolutifs qui alimentent les applications modernes. Notre approche API-first garantit flexibilité, maintenabilité et intégrations fluides.",
    technologies: [
      "Java",
      "Spring Boot",
      "Node.js",
      "NestJS",
      "REST",
      "GraphQL",
    ],
    missions: [
      "Conception d'architecture microservices",
      "Développement d'APIs REST & GraphQL",
      "Modernisation de systèmes legacy",
      "Implémentation d'API gateway",
      "Architecture event-driven",
    ],
    outcomes: [
      "99.9% de disponibilité API",
      "Temps de réponse < 100ms",
      "Intégrations simplifiées",
      "Dette technique réduite",
    ],
  },
  {
    id: "cloud-devops",
    title: "Cloud & DevOps",
    shortDescription:
      "Expertise AWS et Azure avec CI/CD, serverless, containers et Kubernetes.",
    description:
      "Nous accompagnons les organisations dans leur adoption du cloud en toute confiance. Des stratégies de migration aux pipelines entièrement automatisés, nous garantissons une infrastructure résiliente, sécurisée et optimisée en coûts.",
    technologies: [
      "AWS",
      "Azure",
      "Kubernetes",
      "Docker",
      "Terraform",
      "CI/CD",
    ],
    missions: [
      "Migration & stratégie cloud",
      "Implémentation de pipelines CI/CD",
      "Orchestration de containers (Kubernetes)",
      "Architecture serverless",
      "Infrastructure as Code (IaC)",
    ],
    outcomes: [
      "Réduction de 60% du temps de déploiement",
      "Fiabilité système améliorée",
      "Coûts cloud optimisés",
      "Déploiements sans interruption",
    ],
  },
  {
    id: "consulting-architecture",
    title: "Conseil & Architecture",
    shortDescription:
      "Accompagnement stratégique sur le design API-first, l'architecture cloud, les audits techniques et le coaching d'équipes.",
    description:
      "Nous apportons notre expertise pour vous aider à prendre les bonnes décisions techniques. Des revues d'architecture au coaching d'équipe, nous vous aidons à construire des pratiques d'ingénierie durables.",
    technologies: [
      "Architecture Design",
      "Audits Techniques",
      "Coaching d'Équipes",
      "Bonnes Pratiques",
    ],
    missions: [
      "Conception d'architecture technique",
      "Audits de code & d'architecture",
      "Conseil en stratégie API-first",
      "Montée en compétences & coaching d'équipes",
      "Planification de roadmap technologique",
    ],
    outcomes: [
      "Roadmap technique claire",
      "Risque technique réduit",
      "Vélocité d'équipe améliorée",
      "Architecture pérenne",
    ],
  },
];

export const caseStudies = [
  {
    id: "fintech-platform",
    title: "Plateforme de Trading FinTech",
    client: "Grande banque européenne",
    industry: "Finance",
    context:
      "Une grande banque européenne devait moderniser sa plateforme de trading legacy pour gérer l'augmentation des volumes de transactions et les exigences réglementaires.",
    challenge:
      "Le système monolithique existant ne pouvait pas évoluer pour répondre aux pics de demande, causant des problèmes de latence et des plaintes clients.",
    solution:
      "Nous avons conçu et implémenté une architecture microservices avec Spring Boot et Kubernetes. Le traitement des données en temps réel était géré via Apache Kafka.",
    techStack: [
      "Java",
      "Spring Boot",
      "Kubernetes",
      "Apache Kafka",
      "React",
      "PostgreSQL",
      "AWS",
    ],
    results: [
      { metric: "Débit des transactions", value: "x10" },
      { metric: "Réduction latence", value: "85%" },
      { metric: "Disponibilité système", value: "99.99%" },
      { metric: "Conformité", value: "100%" },
    ],
  },
  {
    id: "retail-ecommerce",
    title: "Plateforme Retail Omnicanale",
    client: "Chaîne de distribution mondiale",
    industry: "Distribution",
    context:
      "Une chaîne de distribution mondiale avec plus de 500 magasins avait besoin d'une plateforme unifiée.",
    challenge:
      "Des systèmes déconnectés entraînaient des écarts de stock et une expérience client fragmentée.",
    solution:
      "Nous avons construit une plateforme API-first avec synchronisation de stock en temps réel et profils clients unifiés.",
    techStack: [
      "Node.js",
      "NestJS",
      "React Native",
      "GraphQL",
      "MongoDB",
      "Azure",
      "Redis",
    ],
    results: [
      { metric: "Revenus en ligne", value: "+45%" },
      { metric: "Précision stock", value: "99.5%" },
      { metric: "Satisfaction client", value: "+35 NPS" },
      { metric: "Traitement commandes", value: "2x plus rapide" },
    ],
  },
  {
    id: "industrial-iot",
    title: "Plateforme IoT Industrielle",
    client: "Groupe industriel",
    industry: "Industrie",
    context:
      "Un groupe industriel avec 20 usines dans le monde avait besoin d'une visibilité temps réel sur les équipements.",
    challenge:
      "Les systèmes legacy fournissaient des données retardées, causant des pannes inattendues.",
    solution:
      "Plateforme IoT cloud-native sur AWS avec edge computing et ML pour maintenance prédictive.",
    techStack: [
      "Python",
      "AWS IoT",
      "Lambda",
      "React",
      "TensorFlow",
      "TimescaleDB",
      "Grafana",
    ],
    results: [
      { metric: "Réduction temps d'arrêt", value: "70%" },
      { metric: "Coûts maintenance", value: "-40%" },
      { metric: "Latence données", value: "< 1s" },
      { metric: "Efficacité équipement", value: "+25%" },
    ],
  },
  {
    id: "saas-platform",
    title: "Scaling Plateforme SaaS",
    client: "Startup SaaS B2B",
    industry: "SaaS",
    context:
      "Une startup SaaS devait passer de 100 à 10 000+ clients sans compromettre les performances.",
    challenge:
      "L'architecture initiale ne gérait pas le multi-tenancy. Les requêtes DB ralentissaient les déploiements.",
    solution:
      "Ré-architecture avec patterns multi-tenancy, sharding DB et pipeline CI/CD robuste.",
    techStack: [
      "Node.js",
      "React",
      "PostgreSQL",
      "Kubernetes",
      "GitHub Actions",
      "Datadog",
    ],
    results: [
      { metric: "Capacité clients", value: "x100" },
      { metric: "Performance requêtes", value: "x10" },
      { metric: "Fréquence déploiement", value: "Quotidien" },
      { metric: "Temps réponse incident", value: "< 5min" },
    ],
  },
];

export const benefits = [
  {
    title: "Expertise Senior",
    description:
      "Nos consultants ont en moyenne 10+ ans d'expérience. Pas de juniors.",
  },
  {
    title: "Focus Livraison",
    description:
      "Nous livrons du logiciel fonctionnel. Jalons clairs, résultats mesurables.",
  },
  {
    title: "Approche API-First",
    description: "Systèmes conçus pour l'intégration et l'évolutivité.",
  },
  {
    title: "Cloud Native",
    description: "Solutions résilientes et économiques à l'échelle mondiale.",
  },
];

export const workProcess = [
  {
    step: 1,
    title: "Découvrir",
    description:
      "Nous plongeons dans votre contexte business et vos objectifs.",
  },
  {
    step: 2,
    title: "Concevoir",
    description:
      "Nous architecturons des solutions équilibrant innovation et pragmatisme.",
  },
  {
    step: 3,
    title: "Construire",
    description: "Développement itératif avec livraison en cycles courts.",
  },
  {
    step: 4,
    title: "Opérer",
    description: "Passation fluide, documentation et support long terme.",
  },
];

export const industries = [
  { name: "Finance", icon: "building" },
  { name: "Distribution", icon: "shopping-cart" },
  { name: "Industrie", icon: "factory" },
  { name: "SaaS", icon: "cloud" },
  { name: "Santé", icon: "heart-pulse" },
  { name: "Logistique", icon: "truck" },
];

export const aboutValues = [
  {
    title: "Qualité",
    description: "Pas de raccourcis. Maintenabilité long terme prioritaire.",
  },
  {
    title: "Transparence",
    description:
      "Communication claire, évaluations honnêtes, updates régulières.",
  },
  {
    title: "Ownership",
    description: "Nous traitons votre projet comme le nôtre.",
  },
  {
    title: "Apprentissage Continu",
    description: "Apprentissage constant et partage de connaissances.",
  },
];

export const aboutStory = {
  title: "Notre Histoire",
  content: `Solid Consulting a été fondée en 2024 par une équipe d'ingénieurs seniors frustrés par le statu quo du conseil IT. Trop souvent, nous voyions des projets staffés avec des consultants inexpérimentés.

Nous pensions qu'il existait une meilleure façon. Une ESN qui n'emploierait que des talents seniors. Un partenaire focalisé sur la valeur, pas la facturation.

Aujourd'hui, Solid Consulting compte plus de 10 consultants seniors en Europe et Afrique. 95% de rétention, une dizaine de projets livrés, réputation d'excellence.

Nous ne sommes pas la plus grande ESN — nous sommes celle que vous appelez quand vous avez besoin que ce soit bien fait.`,
};

export const blogPosts = [
  {
    id: "api-first-design",
    title: "Design API-First : Pourquoi c'est Important",
    summary: "Comment l'API-first accélère le développement.",
    category: "Architecture",
    readTime: "8 min",
    date: "2025-07-15",
  },
  {
    id: "microservices-pitfalls",
    title: "5 Pièges Courants des Microservices",
    summary: "Erreurs courantes et comment les éviter.",
    category: "DevOps",
    readTime: "12 min",
    date: "2025-06-28",
  },
  {
    id: "cloud-cost-optimization",
    title: "Optimisation Coûts Cloud : Guide CTO",
    summary: "Réduire AWS/Azure de 30-50%.",
    category: "Cloud",
    readTime: "10 min",
    date: "2025-06-10",
  },
  {
    id: "spring-boot-best-practices",
    title: "Spring Boot en Production",
    summary: "Patterns pour apps robustes à l'échelle.",
    category: "Backend",
    readTime: "15 min",
    date: "2025-05-22",
  },
  {
    id: "kubernetes-migration",
    title: "Migration Kubernetes Étape par Étape",
    summary: "Migrer sans perturber les opérations.",
    category: "DevOps",
    readTime: "14 min",
    date: "2025-05-05",
  },
];

export const faqs = [
  {
    question: "Avec quels types d'entreprises travaillez-vous ?",
    answer:
      "Scale-ups, PME et grands comptes. Finance, distribution, santé, SaaS.",
  },
  {
    question: "Comment garantissez-vous la qualité ?",
    answer:
      "8+ ans d'expérience minimum. Processus de sélection rigoureux. Pas de juniors.",
  },
  {
    question: "Quels modèles d'engagement ?",
    answer:
      "Régie, forfait, équipes dédiées. Nous recommandons selon vos besoins.",
  },
  {
    question: "Travaillez-vous avec nos équipes ?",
    answer:
      "Oui. Nous nous intégrons, renforçons ou guidons selon les besoins.",
  },
  {
    question: "Approche gestion de projet ?",
    answer: "Agile mais pragmatique. Itérations courtes, transparence totale.",
  },
];

export const contactFormFields = [
  { name: "name", label: "Nom complet", type: "text", required: true },
  { name: "company", label: "Entreprise", type: "text", required: true },
  { name: "email", label: "Email", type: "email", required: true },
  {
    name: "projectType",
    label: "Type de projet",
    type: "select",
    required: true,
    options: [
      "Développement Web",
      "Développement Mobile",
      "Backend & APIs",
      "Cloud & DevOps",
      "Conseil & Architecture",
      "Autre",
    ],
  },
  {
    name: "budget",
    label: "Budget",
    type: "select",
    required: false,
    options: [
      "< 50 000 €",
      "50 000 € - 150 000 €",
      "150 000 € - 500 000 €",
      "> 500 000 €",
      "Pas encore défini",
    ],
  },
  { name: "message", label: "Votre projet", type: "textarea", required: true },
];
